import { FONT } from "@/styles/fonts"
import { makeStyles } from "@/utils/makeStyles"

const useStyles = makeStyles(() => ({
	h1: {
		fontSize: FONT.size.h1,
		lineHeight: "1.75rem",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	h2: {
		fontSize: FONT.size.h2,
		lineHeight: "1.25rem",
		fontFamily: "IBM Plex Sans, sans-serif"
	},
	h3: {
		fontSize: FONT.size.h3,
		lineHeight: "1rem",
		fontFamily: "IBM Plex Sans, sans-serif"
	}
}))

export default useStyles